// File: src/api/notes.ts
import { API_BASE, parseJsonSafe } from "./api";

/** ایجاد نوت جدید برای یک تسک */
export async function createNote(projectId: number, taskId: number, content: string) {
  const username = localStorage.getItem("username") ?? "";

  const res = await fetch(`${API_BASE}/projects/${projectId}/tasks/${taskId}/note?username=${encodeURIComponent(username)}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      content,
      isDone: false
    })
  });

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`ایجاد نوت ناموفق بود (${res.status}): ${txt}`);
  }

  const note = await res.json();
  return {
    id: note.taskNoteId ?? note.id,
    content: note.content,
    createdById: note.createdById,
    createdAt: note.createdAt,
    updatedAt: note.updatedAt,
    isDone: note.isDone
  };
}


/** به‌روزرسانی نوت */
export async function updateNote(projectId: number, taskId: number, noteId: number, data: { content?: string; isDone: boolean }) {
  const username = localStorage.getItem("username") ?? "";

  const res = await fetch(
    `${API_BASE}/projects/${projectId}/tasks/${taskId}/note/${noteId}?username=${encodeURIComponent(username)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    }
  );

  if (res.status === 403) {
    const txt = await res.text();
    console.error("Forbidden:", txt);
    throw new Error("شما اجازه ویرایش این نوت را ندارید");
  }
  if (!res.ok) {
    const txt = await res.text();
    console.error("updateNote failed:", txt);
    throw new Error(`ویرایش نوت ناموفق بود (${res.status}): ${txt}`);
  }

  const serverNote = await parseJsonSafe(res, data);
  return {
    id: serverNote.id ?? serverNote.taskNoteId ?? noteId,
    content: serverNote.content ?? data.content ?? "",
    createdById: serverNote.createdById ?? 0,
    createdAt: serverNote.createdAt ?? new Date().toISOString(),
    updatedAt: serverNote.updatedAt ?? new Date().toISOString(),
    isDone: serverNote.isDone ?? data.isDone ?? false
  };
}

/** حذف نوت */
export async function deleteNote(projectId: number, taskId: number, noteId: number) {
  const username = localStorage.getItem("username") ?? "";

  const res = await fetch(
    `${API_BASE}/projects/${projectId}/tasks/${taskId}/note/${noteId}?username=${encodeURIComponent(username)}`,
    { method: "DELETE" }
  );

  if (res.status === 403) {
    throw new Error("شما اجازه حذف این نوت را ندارید");
  }
  if (res.status === 404) {
    throw new Error("نوت پیدا نشد");
  }
  if (!res.ok) {
    throw new Error("حذف نوت ناموفق بود");
  }

  return true;
}

/** دریافت همه نوت‌های یک تسک */
export async function getNotes(projectId: number, taskId: number) {
  const res = await fetch(`${API_BASE}/projects/${projectId}/tasks/${taskId}/note`);
  if (!res.ok) throw new Error("Failed to fetch notes");

  const list = await res.json();
  return list.map((n: any) => ({
    id: n.taskNoteId ?? n.id ?? 0,
    content: n.content ?? "",
    createdById: n.createdById ?? 0,
    createdAt: n.createdAt ?? new Date().toISOString(),
    updatedAt: n.updatedAt ?? new Date().toISOString(),
    isDone: n.isDone ?? false
  }));
}
